
export function generateStaffCompositionTableData(singleTrainerDetails) {
  let parsedData = [];
  singleTrainerDetails?.trainers?.map((trainer) => {
    const {
      firstName,
      middleName,
      lastName,
      yearsOfExperience,
      skill,
      certifications,
    } = trainer;

    const trainerData = {
      firstName,
      middleName,
      lastName,
      yearsOfExperience,
      skill: skill.name,
      certifications: certifications.length,
    };

    parsedData.push(trainerData);
    return null;
  });

  return parsedData;
}

export function generateEquipmentTableData(singleTrainerDetails) {
  let parsedData = [];
  singleTrainerDetails?.skillCenterEquipments?.map((equipment) => {
    const {
      equipmentName,
      equipmentUnits,
      remark,
      skill,
    } = equipment;

    const trainerData = {
      equipmentName,
      equipmentUnits,
      skill: skill.name,
      remark,
    };

    parsedData.push(trainerData);
    return null;
  });

  return parsedData;

}


export function generateCourseTableData(singleTrainerDetails) {
  let parsedData = [];
  singleTrainerDetails?.skillCenterCourseContents?.map((equipment) => {
    const {
      skill,
      hoursPerDay,
      courseDuration, 
    } = equipment;

    const courseData = {
      skill: skill.name, 
      hoursPerDay,
      courseDuration,
    };

    parsedData.push(courseData);
    return null;
  });

  return parsedData;

}